import { render } from "./productImages.vue?vue&type=template&id=5ee2eeed&scoped=true"
import script from "./productImages.vue?vue&type=script&lang=js"
export * from "./productImages.vue?vue&type=script&lang=js"

import "./productImages.vue?vue&type=style&index=0&id=5ee2eeed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee2eeed"]])

export default __exports__